// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyASY2vGXwyORb3ZSlcm3x7O2BlzhQAuEqU",
  authDomain: "justice-24840.firebaseapp.com",
  projectId: "justice-24840",
  storageBucket: "justice-24840.appspot.com",
  messagingSenderId: "978974824887",
  appId: "1:978974824887:web:8b09bc9eadcd27fefd3032"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;